import src from "IMAGE";
export default { src, width: 1000, height: 1000, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAAAAADhZOFXAAAAKUlEQVR42l3KsQkAAAgDQfdfV6tAVIgW4ldXvNVmF+SA7hQQASGBfLNq7Y4/dcKBCAcAAAAASUVORK5CYII="};
